// extracted by mini-css-extract-plugin
export default {"warningList":"bxFxXA5B7vMMkg0RNbTX","input":"pYNVGX3LoYU0Uej3cO8Q"};